module.exports = __webpack_public_path__ + "images/frontpage@2x.png?55823a7b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage@2x.png
// module id = 625
// module chunks = 7